
/* bundle-core.js — the arithmetic EVERY picker option shares. Pure functions, no DOM, no dependencies.
   Pinned by the orchestrator: the builders wire their UI to this and never re-implement it.

   THE MODEL (blueprint C15, 2026-09-17 — Tyler's Q2 on form note_4438): the store now prices by PLAN, not
   by a bag-count ladder — Recharge applies ONE percentage per selling plan (30 / 60 / 90 Day Supply), so a
   widget promising "3 bags = 20%" on the 60-day plan would show a price the cart does not charge. THE BAG
   COUNT PICKS THE PLAN: 1-3 bags -> 30-day supply (20% off) · 4-5 bags -> 60-day supply (25%) · 6-10 bags ->
   90-day supply (30%). Clicking a card sets its default count (2/4/6); adding or removing bags moves the
   count and, at the bracket edges, the selection moves to the next/previous card on its own. MAX_BAGS is 10
   (the store's own ceiling on this plan structure, not a UI-only cap). FREE_SHIP_AT mirrors the store's own
   shipping profile threshold ($75 cart total). A chosen flavour always keeps at least one bag.

   THE MONEY: list $54.98 a bag. TIERS carries save% and perBag PER BRACKET (not by the bag count): 30-day 20%
   $43.98 · 60-day 25% $41.24 · 90-day 30% $38.49. SUBSCRIBE bills bags x perBag with free shipping at >=$75.
   ONE-TIME is list price, no discount, free shipping at the same $75 threshold. The store sets the real
   selling-plan ids and any discount codes; the widget carries the map as data and checkoutUrl is null until
   every chosen flavour has a variant id and the bracket has a selling plan. Change money here only.

   BLUEPRINT C16 (2026-09-18, Tyler's Q10/Q2 on form note_4438): "the price is really only dependent on the
   quantity of bags chosen, not the frequency" — the bag count still picks the MONEY bracket exactly as
   above, but the DELIVERY RHYTHM is now its own explicit choice (state.freq / setFreq / freqOf), decoupled
   from that bracket. The three selling plans were recreated at 0% with new ids (TIERS[].planId) — the
   store's own automatic discounts (by minimum quantity) price the cart now, so checkoutUrl never appends a
   discount code/parameter, on any plan.

   BLUEPRINT C20 (2026-09-19/20, Tyler's eleven picker marks + form note_4787): benefits()'s row 1 now carries
   "/bag" after BOTH prices (mk_mnvh5532) and row 2 is Tyler's own re-order line, verbatim capitals and all,
   the amount off, "off this order", a joining mark, then "EVERY re-order" (mk_p020gd5x); the free-shipping
   row reads "Free shipping on your schedule" (mk_tagsx39o), still last and still absent under the $75 rate.
   NEW: bundleOf(state) (mk_7qy0ah3m) pins step 1's checklist at the SELECTED CARD's own pre-filled bag count
   (2/4/6) rather than the live total — the form under step 2 keeps reading the live state exactly as before;
   nothing else in the core changes.

   BLUEPRINT C22 (2026-09-23, Tyler's nine marks on the picker doc): the re-order row's joining mark is now
   plain text, no dash (mk_pulbzhbp: the words "order" and "and" run on with a single space between them);
   the commitment row loses its middle word and its trailing two-word phrase, reading just "No Commitment,
   Cancel Anytime" now (mk_9rjxf8xx); pickedText() no longer names the delivery rhythm — "4 bags picked ·
   25% off" (mk_kznintcg: "The delivery frequency does not need to be listed here"). NEW: whyRows(state) —
   step 1's checklist reads the CARD's rows (bundleOf) with ONE exception, the re-order row, which follows
   the LIVE count again (mk_omhrot4j: "make this line update with the quantity choice again, not just the
   bundle tile choice"); once mode has no re-order row to follow, so it returns the card's rows unchanged.
   bundleOf() itself is untouched — the head and row 1 still describe the CARD only.

   BLUEPRINT C23 (2026-09-30, Tyler's hub note on the picker doc: "since we are pre-selecting the 60-day card, I
   think that we should also have two chocolate and two vanilla pre-selected, so that way someone could
   literally scroll through it and just hit start my flip without even having to change anything"): NEW
   starter(days) — the state the widget OPENS on: the card's own bag count (2/4/6) split evenly between
   Chocolate and Vanilla, so a shopper can press Start my FLIP without touching anything. create() is
   unchanged (still the empty box); nothing else in the core changes. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.BundleCore = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var SERVINGS_PER_BAG = 15;
  var LIST_PRICE = 54.98;
  var ONE_TIME_PRICE = LIST_PRICE;
  var MAX_BAGS = 10;                      /* the store's real ceiling on this plan structure */
  var FREE_SHIP_AT = 75;                  /* the store's own "Free Shipping & $1.25 Processing Fee" threshold */

  var TIERS = [
    { days: 30, plan: '30 Day Supply', planId: '690145067309', min: 1, max: 3,  bags: 2, save: 20, perBag: 43.98, every: '30 days', weeks: 4,  popular: false, best: false },
    { days: 60, plan: '60 Day Supply', planId: '690145100077', min: 4, max: 5,  bags: 4, save: 25, perBag: 41.24, every: '60 days', weeks: 8,  popular: true,  best: false },
    { days: 90, plan: '90 Day Supply', planId: '690145132845', min: 6, max: 10, bags: 6, save: 30, perBag: 38.49, every: '90 days', weeks: 12, popular: false, best: true  },
  ];
  var FREQS = [30, 60, 90];   /* blueprint C16 (Q10): the delivery rhythms a customer may pick explicitly,
     independent of the bundle/price bracket the bag count selects. */
  var MODES = [
    { id: 'subscribe', label: 'Subscribe & save', short: 'Subscribe' },
    { id: 'once',      label: 'One-time purchase', short: 'One-time' },
  ];

  var FLAVOURS = [
    { id: 'chocolate',     name: 'Chocolate',         short: 'Chocolate',  swatch: '#5A2E1C', img: 'https://landers.appolis.app/fml-flavor-chocolate/media' },
    { id: 'vanilla',       name: 'Vanilla',           short: 'Vanilla',    swatch: '#E9DCC3', img: 'https://landers.appolis.app/fml-flavor-vanilla/media' },
    { id: 'peanut-butter', name: 'Peanut Butter',     short: 'Peanut Butter', swatch: '#B8843B', img: 'https://landers.appolis.app/fml-flavor-peanut-butter/media' },
    { id: 'caramel',       name: 'Caramel',           short: 'Caramel',    swatch: '#C98F4E', img: 'https://landers.appolis.app/fml-flavor-caramel/media' },
    { id: 'cookie-dough',  name: 'Cookie Dough',      short: 'Cookie',     swatch: '#D9C39A', img: 'https://landers.appolis.app/fml-flavor-cookie-dough/media' },
  ];

  /* the TIERS row matching a given SUPPLY (days), for setSupply / checkout plan lookups — exported as `tier` */
  function tierByDays(days) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].days === days) return TIERS[i];
    throw new Error('no such supply: ' + days);
  }
  function flavour(id) {
    for (var i = 0; i < FLAVOURS.length; i++) if (FLAVOURS[i].id === id) return FLAVOURS[i];
    throw new Error('no such flavor: ' + id);
  }
  function modeOf(id) {
    for (var i = 0; i < MODES.length; i++) if (MODES[i].id === id) return MODES[i];
    throw new Error('no such mode: ' + id);
  }

  /* the TIERS row whose bracket [min,max] contains max(n,1) — n > MAX_BAGS is impossible: canInc is false
     at 10, so this never has to look past the top row. */
  function tierFor(n) {
    var m = Math.max(n, 1);
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].min <= m && m <= TIERS[i].max) return TIERS[i];
    return TIERS[TIERS.length - 1];
  }
  /* bags across flavours, as even as possible; the remainder goes to the EARLIEST chosen.
     evenSplit(6, ['chocolate','vanilla']) → {chocolate:3, vanilla:3}
     evenSplit(6, ['a','b','c','d'])       → {a:2, b:2, c:1, d:1}
     evenSplit(4, ['a','b','c'])           → {a:2, b:1, c:1} */
  function evenSplit(bags, ids) {
    var out = {};
    if (!ids.length) return out;
    var base = Math.floor(bags / ids.length), extra = bags % ids.length;
    for (var i = 0; i < ids.length; i++) out[ids[i]] = base + (i < extra ? 1 : 0);
    return out;
  }

  /* a state is { days, mode, chosen: [ids in the order they were chosen], split: {id: bags}, custom: bool }.
     `days` is the SELECTED card while total bags is 0 (defaults to 60 — the popular bracket); the moment at
     least one bag is picked, the displayed/priced supply is always tierFor(totalBags(split)).days instead —
     the count picks the plan, `days` on the state itself just remembers which card to show as checked at
     zero. */
  function create(days) {
    return { days: days || 60, mode: 'subscribe', chosen: [], split: {}, custom: false, freq: null };
  }
  /* blueprint C23 (Tyler's hub note): the state the widget opens on — the card's own bag count split evenly
     between Chocolate and Vanilla (60 → 2 + 2, 30 → 1 + 1, 90 → 3 + 3). A fresh object every call. Rejects a
     supply that is not 30/60/90 (tierByDays throws, exactly as setSupply does). */
  function starter(days) {
    var t = tierByDays(days || 60);
    return next(create(t.days), { chosen: ['chocolate', 'vanilla'], split: evenSplit(t.bags, ['chocolate', 'vanilla']), custom: false });
  }
  function next(state, patch) {
    var s = { days: state.days, mode: state.mode || 'subscribe', chosen: state.chosen.slice(), split: {}, custom: state.custom, freq: state.freq == null ? null : state.freq };
    for (var k in state.split) s.split[k] = state.split[k];
    for (var p in patch) s[p] = patch[p];
    return s;
  }

  function totalBags(split) { var n = 0; for (var k in split) n += split[k]; return n; }
  /* the supply this state is priced/labeled at RIGHT NOW: the real total's own bracket once >=1 bag is
     picked, else the last card the user clicked (state.days). */
  function daysFor(state) {
    var total = totalBags(state.split);
    return total >= 1 ? tierFor(total).days : state.days;
  }
  function tierOf(state) { return tierByDays(daysFor(state)); }
  /* blueprint C16 (Q10, DESIGN §1): the delivery RHYTHM is independent of the bundle/price bracket the bag
     count picks. null = "follow the bundle" (the rhythm is tierFor(effectiveBags).days); 30/60/90 = the
     customer's own explicit choice, which survives a bracket change until they pick a different SUPPLY card
     (setSupply resets it to null — a card click chooses the bundle WITH its rhythm again). */
  function freqOf(state) { return (state.freq == null ? null : state.freq) || tierFor(effectiveBags(state)).days; }
  function setFreq(state, days) { tierByDays(days); return next(state, { freq: days }); }
  /* the card's default previews the money — effectiveBags is the displayed total (the tier's default while
     nothing is picked yet, else the actual total). */
  function effectiveBags(state) {
    var total = totalBags(state.split);
    return total > 0 ? total : tierOf(state).bags;
  }

  /* choose a supply. Kept flavours survive, capped at the new tier's bag count; an empty box defaults to
     Chocolate (setSupply always leaves REAL bags behind — it is how a card click assigns real inventory,
     not just a preview). The split is redone evenly — a custom split cannot survive a change of total. */
  function setSupply(state, days) {
    var t = tierByDays(days);
    var chosen = state.chosen.length ? state.chosen.slice(0, t.bags) : ['chocolate'];
    return next(state, { days: days, chosen: chosen, split: evenSplit(t.bags, chosen), custom: false, freq: null });
  }

  /* subscribe or buy once — money only; the box is untouched */
  function setMode(state, mode) {
    modeOf(mode);
    return next(state, { mode: mode });
  }

  /* tap a flavour: add it (if there is a bag left to give it) or remove it. */
  function toggleFlavour(state, id) {
    flavour(id);
    var chosen = state.chosen.slice();
    var i = chosen.indexOf(id);
    if (i > -1) chosen.splice(i, 1);
    else chosen.push(id);
    var total = totalBags(state.split);
    if (chosen.length > state.chosen.length && total >= MAX_BAGS) return state;
    if (i > -1) {
      var newTotal = total - (state.split[id] || 0);
      return next(state, { chosen: chosen, split: evenSplit(newTotal, chosen), custom: state.custom });
    }
    var addedTotal = total + 1;
    if (addedTotal > MAX_BAGS) return state;
    var split = {};
    for (var k in state.split) split[k] = state.split[k];
    split[id] = 1;
    return next(state, { chosen: chosen, split: split, custom: true });
  }

  function canAddFlavour(state) { return totalBags(state.split) < MAX_BAGS; }

  /* SWAP: the box is full and the customer wants another flavour — a tile is never disabled; instead one
     flavour they have goes out and the new one takes its place AND its bags. */
  function swapFlavour(state, outId, inId) {
    flavour(outId); flavour(inId);
    if (outId === inId) return state;
    if (state.chosen.indexOf(outId) < 0 || state.chosen.indexOf(inId) > -1) return state;
    var chosen = state.chosen.map(function (id) { return id === outId ? inId : id; });
    var split = {};
    for (var i = 0; i < chosen.length; i++) { var id = chosen[i]; split[id] = state.split[id === inId ? outId : id]; }
    return next(state, { chosen: chosen, split: split, custom: state.custom });
  }

  /* COUNTERS: "+" and "−" inside each flavour tile. A "+" at MAX_BAGS does nothing (frozen — same state back);
     a "−" to zero un-chooses the flavour. The order of first "+" is the chosen order. */
  function incBag(state, id) {
    flavour(id);
    var total = totalBags(state.split);
    if (total >= MAX_BAGS) return state;
    var chosen = state.chosen.slice(), split = {};
    for (var k in state.split) split[k] = state.split[k];
    if (chosen.indexOf(id) < 0) { chosen.push(id); split[id] = 0; }
    split[id] += 1;
    return next(state, { chosen: chosen, split: split, custom: true });
  }
  function decBag(state, id) {
    flavour(id);
    if (state.chosen.indexOf(id) < 0 || !(state.split[id] > 0)) return state;
    var chosen = state.chosen.slice(), split = {};
    for (var k in state.split) split[k] = state.split[k];
    split[id] -= 1;
    if (split[id] === 0) { delete split[id]; chosen.splice(chosen.indexOf(id), 1); }
    return next(state, { chosen: chosen, split: split, custom: true });
  }
  function canInc(state) { return totalBags(state.split) < MAX_BAGS; }

  /* the words beside the counters, and the CTA's label — from the real total only (0 really means nothing
     picked, not a preview). */
  function pickedText(state) {
    var n = totalBags(state.split);
    if (n === 0) return 'Pick your bags.';
    var t = tierFor(n);
    return n + ' bag' + (n === 1 ? '' : 's') + ' picked · ' + t.save + '% off';
  }
  function ctaText(state) {
    var n = totalBags(state.split);
    if (n === 0) return 'Pick your bags first';
    return 'Start my FLIP →';
  }
  function onceLine(state) {
    var T = totals(setMode(state, 'once'));
    return 'Prefer to buy once? ' + T.billedText + ' for ' + T.bags + ' bag' + (T.bags === 1 ? '' : 's') + ', ' + (T.freeShipping ? 'free shipping' : 'plus shipping');
  }

  /* CHECKOUT. checkoutUrl() returns null until every chosen flavour has a variant id and the resolved
     plan (freqOf — the customer's chosen delivery rhythm, or the bundle's own default) has a selling plan
     id — the store fills SHOPIFY in one place; nothing else changes. Shape: a Shopify cart permalink —
     https://flipmylifenow.com/cart/<variant>:<qty>,<variant>:<qty>?selling_plan=<plan> (no selling_plan =
     one-time). blueprint C16 (§0, §1): the store's own automatic discounts price the cart by minimum
     quantity — the widget NEVER appends a discount code/parameter, on any plan, even when a codes map is
     passed in (Recharge renewals + the storefront's Bundle & Save discounts already do that job). */
  var SHOPIFY = { store: 'https://flipmylifenow.com', variants: {}, onceVariants: {}, plans: {} };
  function variantFor(id, mode, shop) {
    var S = shop || SHOPIFY;
    return (mode === 'once' && S.onceVariants && S.onceVariants[id]) || S.variants[id];
  }
  function checkoutUrl(state, mode, shop) {
    var S = shop || SHOPIFY, m = mode || state.mode || 'subscribe';
    var total = totalBags(state.split);
    if (!state.chosen.length || total === 0) return null;
    var parts = [];
    for (var i = 0; i < state.chosen.length; i++) {
      var id = state.chosen[i], v = variantFor(id, m, S);
      if (!v) return null;
      parts.push(v + ':' + state.split[id]);
    }
    if (m === 'subscribe') {
      var days = freqOf(state);
      var plan = S.plans[days];
      if (!plan) return null;
      return S.store + '/cart/' + parts.join(',') + '?selling_plan=' + plan;
    }
    return S.store + '/cart/' + parts.join(',');
  }

  /* move ONE bag from one chosen flavour to another. The giver keeps at least one bag. */
  function moveBag(state, fromId, toId) {
    if (fromId === toId) return state;
    if (state.chosen.indexOf(fromId) < 0 || state.chosen.indexOf(toId) < 0) return state;
    if (state.split[fromId] <= 1) return state;
    var split = {}; for (var k in state.split) split[k] = state.split[k];
    split[fromId] -= 1; split[toId] += 1;
    return next(state, { split: split, custom: true });
  }

  /* "one more of X" — takes the bag from the flavour that currently has the MOST (ties: the latest chosen) */
  function addBag(state, toId) {
    var donor = null, most = -1;
    for (var i = state.chosen.length - 1; i >= 0; i--) {
      var id = state.chosen[i];
      if (id !== toId && state.split[id] > 1 && state.split[id] > most) { most = state.split[id]; donor = id; }
    }
    return donor ? moveBag(state, donor, toId) : state;
  }
  /* "one fewer of X" — gives the bag to the flavour that currently has the FEWEST (ties: the earliest chosen) */
  function removeBag(state, fromId) {
    var taker = null, fewest = Infinity;
    for (var i = 0; i < state.chosen.length; i++) {
      var id = state.chosen[i];
      if (id !== fromId && state.split[id] < fewest) { fewest = state.split[id]; taker = id; }
    }
    return taker ? moveBag(state, fromId, taker) : state;
  }

  function resetEven(state) {
    return next(state, { split: evenSplit(totalBags(state.split), state.chosen), custom: false });
  }

  /* THE BOX: "make bag number i this flavour". The bag's current flavour gives one up; if that was its last
     bag the flavour leaves the box. A flavour not yet chosen joins at the end with that one bag. */
  function setBag(state, slotIndex, toId) {
    flavour(toId);
    var bags = bagList(state);
    var fromId = bags[slotIndex];
    if (fromId === undefined || fromId === null || fromId === toId) return state;
    var chosen = state.chosen.slice(), split = {};
    for (var k in state.split) split[k] = state.split[k];
    split[fromId] -= 1;
    if (split[fromId] === 0) { delete split[fromId]; chosen.splice(chosen.indexOf(fromId), 1); }
    if (chosen.indexOf(toId) < 0) { chosen.push(toId); split[toId] = 0; }
    split[toId] += 1;
    return next(state, { chosen: chosen, split: split, custom: true });
  }

  /* THREE QUESTIONS: "mostly X" — X takes every bag the others do not strictly need; the others keep one each */
  function mostly(state, id) {
    if (state.chosen.indexOf(id) < 0 || state.chosen.length < 2) return state;
    var total = totalBags(state.split);
    var split = {};
    for (var i = 0; i < state.chosen.length; i++) split[state.chosen[i]] = 1;
    split[id] = total - (state.chosen.length - 1);
    return next(state, { split: split, custom: true });
  }
  /* which preset is the state in — 'even', 'mostly:<id>', or 'custom' */
  function mixOf(state) {
    var total = totalBags(state.split), k = state.chosen.length;
    if (!k || !total) return 'even';
    var even = evenSplit(total, state.chosen), isEven = true;
    for (var i = 0; i < k; i++) if (even[state.chosen[i]] !== state.split[state.chosen[i]]) isEven = false;
    if (isEven) return 'even';
    if (k >= 2) for (var j = 0; j < k; j++) {
      var id = state.chosen[j], ok = state.split[id] === total - (k - 1);
      if (ok) for (var m = 0; m < k; m++) if (state.chosen[m] !== id && state.split[state.chosen[m]] !== 1) ok = false;
      if (ok) return 'mostly:' + id;
    }
    return 'custom';
  }

  function money(n) { return '$' + n.toFixed(2); }

  function totals(state) {
    var t = tierOf(state);   /* the MONEY bracket — from the bag COUNT only, never the delivery rhythm */
    var once = (state.mode || 'subscribe') === 'once';
    var bags = effectiveBags(state);
    var perBag = once ? LIST_PRICE : t.perBag;
    var save = once ? 0 : t.save;
    var billed = +(bags * perBag).toFixed(2);
    var freeShipping = billed >= FREE_SHIP_AT;
    var savings = +(bags * (LIST_PRICE - perBag)).toFixed(2);
    var tag = t.popular ? 'Most popular' : (t.best ? 'Best value' : null);
    /* the delivery rhythm shown/billed against — freqOf() while subscribing (follows the bundle unless the
       customer set it explicitly); once-mode has no recurring plan at all. */
    var freq = once ? null : freqOf(state);
    var billedLine = once ? (money(billed) + ', one time') : ('Billed ' + money(billed) + ' every ' + freq + ' days');
    return {
      savings: savings, savingsText: money(savings), tag: tag,
      why: money(perBag) + '/bag — you save ' + money(savings),
      days: t.days, plan: t.plan, planId: t.planId, bags: bags, every: t.every, freq: freq, freqEvery: freq ? (freq + ' days') : null, weeks: t.weeks, popular: t.popular, best: t.best,
      mode: once ? 'once' : 'subscribe', once: once, modeLabel: modeOf(once ? 'once' : 'subscribe').label,
      save: save, saveText: save ? 'Save ' + save + '%' : '',
      freeShipping: freeShipping,
      /* blueprint C18 (Tyler, form note_4723 Q3: "that line just appears and disappears"): the shipping
         perk is ONE row that EXISTS only once the cart clears FREE_SHIP_AT — no struck/how machinery any
         more (C17's bagsToFreeShipping/shippingHow are gone); shippingText is the empty string under the
         rate so a plain-text consumer (priceLine) can simply skip the part, never printing a dash. */
      shippingText: freeShipping ? 'Free shipping' : '',
      perBag: perBag, perBagText: money(perBag), listPrice: LIST_PRICE, listPriceText: money(LIST_PRICE),
      billed: billed, billedText: money(billed), billedLine: billedLine,
      perServing: +(perBag / SERVINGS_PER_BAG).toFixed(2), perServingText: money(+(perBag / SERVINGS_PER_BAG).toFixed(2)),
      servings: bags * SERVINGS_PER_BAG,
      assigned: totalBags(state.split), unassigned: 0,
      complete: totalBags(state.split) >= 1 && state.chosen.length > 0,
    };
  }

  /* THE BENEFITS CHECKLIST: what this choice gets you, in display order. Subscribe carries the deal rows;
     one-time carries none (mk_kgct7iqr's exact wording, Tyler's casing kept). Blueprint C18 (Tyler's marks
     mk_pfntfnwa/mk_gt804rsx/Q3): row 1 is the "Vs" savings line, row 2 is the REAL-savings line, and the
     shipping row simply is not there under the free-shipping rate — no `how` key on any row any more, and
     every row is ok:true (a row that has not been earned is just absent, never struck). Blueprint C20
     (mk_mnvh5532/mk_p020gd5x/mk_tagsx39o): row 1 now carries "/bag" after BOTH prices, row 2 is Tyler's own
     verbatim re-order line, and the shipping row (subscribe mode only) reads "on your schedule". */
  function benefits(state) {
    var T = totals(state), rows = [];
    if (T.once) {
      rows.push({ ok: true, text: '30-day money-back guarantee' });
      if (T.freeShipping) rows.push({ ok: true, text: 'Free shipping' });
    } else {
      rows.push({ ok: true, text: 'Save ' + T.save + '% — ' + money(T.perBag) + '/bag vs ' + money(LIST_PRICE) + '/bag' });
      rows.push({ ok: true, text: T.savingsText + ' off this order and EVERY re-order' });
      rows.push({ ok: true, text: 'No Commitment, Cancel Anytime' });
      rows.push({ ok: true, text: '30-day money-back guarantee' });
      if (T.freeShipping) rows.push({ ok: true, text: 'Free shipping on your schedule' });
    }
    return rows;
  }

  /* the checklist's heading: "60-day supply · Most popular" · "30-day supply" · once → "90-day supply · bought once" */
  function benefitsHead(state) {
    var T = totals(state);
    if (T.once) return T.days + '-day supply · bought once';
    return T.days + '-day supply' + (T.tag ? ' · ' + T.tag : '');
  }

  /* THE PRICE CELLS: the one price line broken up into value + label cells */
  function priceCells(state) {
    var T = totals(state), cells = [{ v: T.perBagText, l: 'per bag' }];
    if (T.once) {
      cells.push({ v: T.freeShipping ? 'Free' : 'Plus', l: 'shipping' });
      cells.push({ v: 'Once', l: 'billed' });
    } else {
      cells.push({ v: T.saveText, l: 'off ' + T.listPriceText });
      cells.push({ v: T.freeShipping ? 'Free' : 'Plus', l: 'shipping' });
      cells.push({ v: 'Every ' + T.freq + ' days', l: 'delivered' });
    }
    return cells;
  }

  /* THE FLAVOUR COUNTS: one tile per CHOSEN flavour with its number — never a colour without one */
  function counts(state) {
    var out = [];
    for (var i = 0; i < state.chosen.length; i++) {
      var f = flavour(state.chosen[i]);
      out.push({ id: f.id, short: f.short, name: f.name, swatch: f.swatch, count: state.split[f.id] || 0 });
    }
    return out;
  }

  /* THE PRESETS WORTH SHOWING: a "Mostly X" is hidden only while it would give the split you ALREADY have. */
  function mixOptions(state) {
    var opts = [{ id: 'even', label: 'Evenly' }];
    if (state.chosen.length < 2) return opts;
    var cur = JSON.stringify(state.split), onEven = mixOf(state) === 'even';
    for (var i = 0; i < state.chosen.length; i++) {
      var id = state.chosen[i];
      if (onEven && JSON.stringify(mostly(state, id).split) === cur) continue;
      opts.push({ id: 'mostly:' + id, label: 'Mostly ' + flavour(id).short });
    }
    return opts;
  }

  /* the ONE price line under the supply control, e.g. "$43.98 a bag · Save 20% · Free shipping · billed every 30 days"
     — blueprint C18 (Q3): the shipping part is skipped entirely (not a blank " · ") while T.shippingText is empty. */
  function priceLine(state) {
    var T = totals(state), parts = [T.perBagText + '/bag'];
    if (T.saveText) parts.push(T.saveText);
    if (T.shippingText) parts.push(T.shippingText);
    parts.push(T.once ? 'billed once' : 'billed every ' + T.freq + ' days');
    return parts.join(' · ');
  }

  /* the sentence a human would say about this state — every option can reuse it. blueprint C16 (DESIGN §1):
     the "<days>-day supply ·" prefix is DROPPED — a 3-bag box delivered every 60 days (an explicit freq
     choice) is not itself a "60-day supply"; the bag count is the bundle, the day count is just the rhythm. */
  function describe(state) {
    if (!state.chosen.length) return 'Pick at least one flavor.';
    var n = totalBags(state.split);
    var T = totals(state);
    var parts = [];
    for (var i = 0; i < state.chosen.length; i++) {
      var id = state.chosen[i];
      parts.push(state.split[id] + ' ' + flavour(id).short);
    }
    var list = parts.length === 1 ? parts[0] : parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1];
    return n + ' bag' + (n === 1 ? '' : 's') + ': ' + list + ' · ' + T.billedText + ' every ' + freqOf(state) + ' days';
  }

  /* the bags as an ordered list of flavour ids (for ledger renderings): grouped, in chosen order, padded to
     the CURRENT bracket's default (or the real total if it already exceeds that default). */
  function bagList(state) {
    var out = [];
    for (var i = 0; i < state.chosen.length; i++) {
      var id = state.chosen[i];
      for (var n = 0; n < (state.split[id] || 0); n++) out.push(id);
    }
    while (out.length < tierOf(state).bags) out.push(null);
    return out;
  }

  /* blueprint C16 (DESIGN §1) — the ledger's own heading: 'Your bundle' while nothing is picked, else 'Your
     bundle · N bags' (never a day count — the ledger is about the BOX, whose size is the bag count; the
     delivery rhythm lives in the .oc-freq control instead). */
  function ledgerTitle(state) {
    var n = totalBags(state.split);
    return n === 0 ? 'Your bundle' : 'Your bundle · ' + n + ' bag' + (n === 1 ? '' : 's');
  }

  /* blueprint C20 (mk_7qy0ah3m): STEP 1 describes the BUNDLE CARD, not the live count — the same state pinned at the
     selected card's own pre-filled count (2/4/6). Which card is selected still follows the live count's bracket
     (tierFor — the card moves the moment a bracket's minimum is reached, and moves back when the count drops under
     it); everything under step 2 and in the form keeps reading the live state. Mode and an explicit freq survive. */
  function bundleOf(state) {
    var t = tierOf(state);
    return next(state, { chosen: ['chocolate'], split: { chocolate: t.bags }, custom: false });
  }

  /* blueprint C22 (mk_omhrot4j): STEP 1's checklist reads the CARD's rows (benefits(bundleOf(state))) except
     for the re-order row, which keeps following the LIVE count — "make this line update with the quantity
     choice again, not just the bundle tile choice". Subscribe only: once mode has no re-order row to swap in,
     so its two rows (guarantee, and shipping once earned) are the card's, unchanged. Never mutates its input. */
  function whyRows(state) {
    var card = benefits(bundleOf(state));
    if ((state.mode || 'subscribe') === 'once') return card;
    var live = benefits(state);
    var rows = card.slice();
    if (rows.length > 1 && live.length > 1) rows[1] = live[1];
    return rows;
  }

  return {
    SERVINGS_PER_BAG: SERVINGS_PER_BAG, LIST_PRICE: LIST_PRICE, ONE_TIME_PRICE: ONE_TIME_PRICE, MAX_BAGS: MAX_BAGS, FREE_SHIP_AT: FREE_SHIP_AT, TIERS: TIERS, MODES: MODES, FLAVOURS: FLAVOURS, FREQS: FREQS,
    tier: tierByDays, tierFor: tierFor, flavour: flavour, modeOf: modeOf, evenSplit: evenSplit,
    create: create, starter: starter, setSupply: setSupply, setMode: setMode, setFreq: setFreq, freqOf: freqOf, toggleFlavour: toggleFlavour, canAddFlavour: canAddFlavour, swapFlavour: swapFlavour,
    incBag: incBag, decBag: decBag, canInc: canInc, pickedText: pickedText, ctaText: ctaText, onceLine: onceLine, checkoutUrl: checkoutUrl, variantFor: variantFor, SHOPIFY: SHOPIFY,
    moveBag: moveBag, addBag: addBag, removeBag: removeBag, resetEven: resetEven, setBag: setBag, mostly: mostly, mixOf: mixOf,
    totals: totals, priceLine: priceLine, benefits: benefits, benefitsHead: benefitsHead, priceCells: priceCells, counts: counts, mixOptions: mixOptions, describe: describe, bagList: bagList, money: money,
    effectiveBags: effectiveBags, daysFor: daysFor, ledgerTitle: ledgerTitle, bundleOf: bundleOf, whyRows: whyRows,
  };
});


/* lander bridge — the store's own ids */
window.BundleCore.SHOPIFY.store = "https://flipmylifenow.com";
window.BundleCore.SHOPIFY.variants = {"chocolate":"52364761891117","vanilla":"52364761923885","peanut-butter":"52364761956653","caramel":"52364761989421","cookie-dough":"52364762022189"};
window.BundleCore.SHOPIFY.onceVariants = {"chocolate":"51776853147949","vanilla":"51776853180717","peanut-butter":"51776853213485","caramel":"51776853246253","cookie-dough":"51776853279021"};
window.BundleCore.SHOPIFY.plans = {"30":"690145067309","60":"690145100077","90":"690145132845"};
window.BundleCore.SHOPIFY.codes = {};


(function(){
  'use strict';
  var BC = window.BundleCore;
  var root = (document.currentScript && document.currentScript.closest('section.option[data-option="c"]'))
    || document.querySelector('section.option[data-option="c"]');
  if (!root || !BC) return;

  /* blueprint C30 (Tyler, form note_5074: "let's change it back to not having any flavors selected at first. update this on
     every version"): the widget OPENS empty again, as it did before C23 — the 60-day card checked, no bags in the box, the CTA
     "Pick your bags first". The core's own starter() helper stays (unused by this controller). */
  var state = BC.create(60);
  var transientHint = null;

  var widgetEl = root.querySelector('.oc-widget');
  var daysEls = root.querySelectorAll('[data-days]');
  var tileEls = root.querySelectorAll('.oc-fl');
  var flavoursEl = root.querySelector('.oc-flavours');
  var whyEl = root.querySelector('.oc-why');
  var whyHeadEl = root.querySelector('.oc-why-head');
  var pickedEl = root.querySelector('.oc-picked');
  var toastEl = root.querySelector('.oc-toast');
  var toastTimer = null;
  var hintEl = root.querySelector('.oc-hint');
  var priceCountEl = root.querySelector('.oc-price-count');
  var wasEl = root.querySelector('.oc-was');
  var nowNumEl = root.querySelector('.oc-now-num');
  var billedEl = root.querySelector('.oc-billed');
  var perksEl = root.querySelector('.oc-perks');
  var formEl = root.querySelector('.oc-form');
  var itemsEl = root.querySelector('.oc-items');
  var retEl = root.querySelector('.oc-ret');
  var landerEl = root.querySelector('.oc-lander');
  var refEl = root.querySelector('.oc-ref');
  var uaEl = root.querySelector('.oc-ua');
  var urlEl = root.querySelector('.oc-url');
  var adEl = root.querySelector('.oc-ad');
  var onceEl = root.querySelector('.oc-once');
  var onceQEl = root.querySelector('.oc-once-q');
  var onceVEl = root.querySelector('.oc-once-v');
  var ctaEl = root.querySelector('.oc-cta');
  var headEmEl = root.querySelector('.oc-head-em');

  /* blueprint C15: the "up to N%" in the header comes from TIERS' own top save% (the store's 90-day
     bracket, 30%) — no LADDER any more. */
  if (headEmEl) {
    var maxSave = 0;
    for (var si = 0; si < BC.TIERS.length; si++) if (BC.TIERS[si].save > maxSave) maxSave = BC.TIERS[si].save;
    headEmEl.textContent = 'up to ' + maxSave + '%';
  }

  /* the attribution inputs describe THIS page load — filled once, never touched by render() again */
  if (landerEl) landerEl.value = (widgetEl && widgetEl.getAttribute('data-lander')) || '';
  if (refEl) refEl.value = document.referrer || '';
  if (uaEl) uaEl.value = navigator.userAgent || '';
  if (urlEl) urlEl.value = location.href || '';
  if (adEl) {
    var adVal = '';
    try { adVal = new URLSearchParams(location.search).get('ad') || ''; } catch (adErr) {}
    adEl.value = adVal;
  }

  /* blueprint C16 (§2, mk_lbveduux): "10 bags is the most per order." — shown ~2.5s then gone, role="status"
     so it announces without stealing focus or shifting layout (position:absolute, above). */
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2500);
  }

  /* blueprint C15 (DESIGN §1/§2): the bag count picks the plan — the checked card follows BC.daysFor(state).
     Blueprint C18 (mk_pe40vje8): no nudge any more — every pill just reads its own bracket's plain
     "Save N%", selected or not. Blueprint C20 (mk_7qy0ah3m): the cards describe the CARD, not the live
     count any more — every card ALWAYS shows its own bracket's default bag count and per-bag price (the
     `live` branch and its own per-card marker attribute are gone); only which card is CHECKED still follows the live total.
     Blueprint C36 (Tyler, chat: "If any quantity amount is chosen in the flavor selector that is not two, four, and six bags, then no
     card should be highlighted. The card should only highlight whenever that quantity has been chosen, or the card itself has been
     picked."): a card is checked only while the box holds exactly ITS bag count — 2, 4 or 6 (a card tap fills exactly that count);
     1, 3, 5 and 7–10 bags check none. The empty box keeps the card it opens on, or the last one tapped (state.days): the bundle the
     price line previews. The money, the plan and step 1's checklist still follow the bracket (BC.daysFor / BC.bundleOf). */
  function litDays() {
    var n = 0;
    for (var k in state.split) n += state.split[k];
    if (n === 0) return state.days;
    for (var i = 0; i < BC.TIERS.length; i++) if (BC.TIERS[i].bags === n) return BC.TIERS[i].days;
    return null;
  }
  function renderDays() {
    var selectedDays = litDays();
    for (var i = 0; i < daysEls.length; i++) {
      var btn = daysEls[i];
      var d = +btn.getAttribute('data-days');
      var isSel = d === selectedDays;
      btn.setAttribute('aria-checked', isSel ? 'true' : 'false');
      var tierD = BC.tier(d);
      var tag = tierD.popular ? 'Most popular' : (d === 90 ? 'Best value' : '');
      var tagEl = btn.querySelector('.oc-day-tag');
      var bEl = btn.querySelector('.oc-day-b');
      var pillEl = btn.querySelector('.oc-day-pill');
      var priceEl = btn.querySelector('.oc-day-price');
      if (tagEl) { tagEl.textContent = tag; tagEl.hidden = !tag; }
      if (bEl) { bEl.textContent = tierD.bags + ' bag' + (tierD.bags === 1 ? '' : 's'); }
      if (pillEl) pillEl.textContent = 'Save ' + tierD.save + '%';
      if (priceEl) priceEl.textContent = BC.money(tierD.perBag) + '/bag';
    }
  }

  /* blueprint C18 (mk_2y9bd7it): every row BC.benefits() returns is ok:true now — nothing is ever struck, so
     this is just plain text, shared by renderWhy and renderPerks so both checklists fill the same way. */
  function fillRowText(el, row) {
    el.textContent = row.text;
  }

  /* blueprint C20 (mk_7qy0ah3m): step 1's checklist head reads BC.bundleOf(state) — the state pinned at the
     SELECTED CARD's own pre-filled bag count (2/4/6) — not the live state. Blueprint C22 (mk_omhrot4j):
     the ROWS instead read BC.whyRows(state) — the card's rows, EXCEPT the re-order row, which follows the
     live count again ("make this line update with the quantity choice again, not just the bundle tile
     choice"). Everything under step 2 (renderPerks, the price row, the billed line, the ledger, the once
     line and the CTA) keeps reading the live `state` exactly as before; which card is checked still follows
     the live count's bracket (BC.daysFor), so the two lists always agree the moment a bracket boundary is
     crossed. The owner's call (form note_4787 Q1's ✏️ line + mk_7qy0ah3m/mk_omhrot4j). */
  function renderWhy() {
    var head = BC.benefitsHead(BC.bundleOf(state));
    var rows = BC.whyRows(state);
    /* blueprint C24 (mk_epbyt5lu): the head is its own <p> ABOVE the box now, not the box's first <li> — only its text follows the card. */
    if (whyHeadEl) whyHeadEl.textContent = head;
    whyEl.innerHTML = '';
    for (var i = 0; i < rows.length; i++) {
      var li = document.createElement('li');
      li.className = 'oc-why-row';
      li.setAttribute('data-ok', rows[i].ok ? 'true' : 'false');
      var span = document.createElement('span');
      span.className = 'oc-why-t';
      fillRowText(span, rows[i]);
      li.appendChild(span);
      whyEl.appendChild(li);
    }
  }

  /* round six, mark mk_gag5xav6: each tile carries its own count, driven straight off state.split — a "−"
     at zero is disabled, never a click that does nothing silently. Blueprint C16 (§2, mk_lbveduux): "+"
     stays ENABLED even at 10 bags now — a tap there does not add (incBag's own frozen-input guard) but
     surfaces the toast rather than just going quiet, so the click handler below is the one that checks
     canInc, not this disabled attribute. */
  function renderTiles() {
    var any = false;
    for (var i = 0; i < tileEls.length; i++) {
      var tile = tileEls[i];
      var id = tile.getAttribute('data-flavour');
      var count = state.split[id] || 0;
      var picked = count > 0;
      if (picked) any = true;
      tile.setAttribute('data-picked', picked ? 'true' : 'false');
      var qvEls = tile.querySelectorAll('.oc-qv');
      for (var qi = 0; qi < qvEls.length; qi++) qvEls[qi].textContent = String(count);
      var decEls = tile.querySelectorAll('[data-dec]');
      for (var di = 0; di < decEls.length; di++) decEls[di].disabled = count === 0;
    }
    /* blueprint C31 (form note_5084): the unpicked pouches fade only once the box holds a bag; an empty box keeps all five bright */
    if (flavoursEl) flavoursEl.setAttribute('data-any', any ? 'true' : 'false');
  }

  /* blueprint C18 (mk_2y9bd7it: "it may be weird that these do not match the check marks at the top... I
     don't think there should be a drift here"): the perks list under the price is now THE SAME ROWS as the
     checklist, same order — BC.benefits(state) in full (5 rows subscribe / 2 rows once / 4 or 1 while the
     money is under the free-shipping rate); every li is plain text, ok:true, with the ✓ CSS already draws. */
  function renderPerks() {
    var rows = BC.benefits(state);
    perksEl.innerHTML = '';
    for (var i = 0; i < rows.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-ok', 'true');
      fillRowText(li, rows[i]);
      perksEl.appendChild(li);
    }
  }

  /* round ten (marks mk_8h7ydr1v + mk_kg303zo5 + mk_75qptohr): the LEDGER replaces the carton as the box.
     One distinct row per picked flavor, first-pick order, plus placeholder rows for what's left. Fills
     EVERY .oc-ledger in the section (the form copy and the tablet step copy) from the same state. */
  function distinctCounts(picked) {
    var seen = [], counts = {};
    for (var i = 0; i < picked.length; i++) {
      var id = picked[i];
      if (!counts[id]) { counts[id] = 0; seen.push(id); }
      counts[id]++;
    }
    return { seen: seen, counts: counts };
  }

  function renderLedger() {
    var t = BC.tier(BC.daysFor(state));
    var picked = BC.bagList(state).filter(function (id) { return !!id; });
    var dc = distinctCounts(picked);
    /* blueprint C16 (DESIGN §1): the ledger heading is about the BOX (the bag count), never the day — the
       delivery rhythm lives in its own tiny dropdown instead (blueprint C18, mk_s9e23cb5). */
    var title = BC.ledgerTitle(state);
    var segCount = Math.max(t.bags, picked.length);
    var bar = '';
    for (var b = 0; b < segCount; b++) bar += '<i' + (b < picked.length ? ' class="on"' : '') + '></i>';
    var rows = '';
    for (var r = 0; r < dc.seen.length; r++) {
      var f = BC.flavour(dc.seen[r]);
      rows += '<li class="oc-ledger-row"><span class="oc-ledger-dot" style="background:' + f.swatch + '"></span><span class="oc-ledger-name">' + f.name + '</span><span class="oc-ledger-n">×' + dc.counts[dc.seen[r]] + '</span></li>';
    }
    var remaining = segCount - picked.length;
    for (var e = 0; e < remaining; e++) rows += '<li class="oc-ledger-row oc-ledger-empty">—</li>';
    var showHint = picked.length === 0;
    var ledgers = root.querySelectorAll('.oc-ledger');
    for (var i = 0; i < ledgers.length; i++) {
      var led = ledgers[i];
      var titleEl = led.querySelector('.oc-ledger-title');
      var barEl = led.querySelector('.oc-ledger-bar');
      var rowsEl = led.querySelector('.oc-ledger-rows');
      var hintEl2 = led.querySelector('.oc-ledger-hint');
      if (titleEl) titleEl.textContent = title;
      if (barEl) barEl.innerHTML = bar;
      if (rowsEl) rowsEl.innerHTML = rows;
      if (hintEl2) hintEl2.hidden = !showHint;
    }
    requestAnimationFrame(function () {
      var newRows = root.querySelectorAll('.oc-ledger-row');
      for (var j = 0; j < newRows.length; j++) newRows[j].classList.add('is-in');
    });
  }

  /* round six, mark mk_cx0dcduo: the cart form's hidden line items — rebuilt on every render, and again the
     instant the one-time link is tapped. Nothing renders until every id the box needs actually resolves to a
     Shopify id; the store has no maps yet (SHOPIFY.variants is empty), so this is always empty today.
     Resolves each id through BC.variantFor(id, mode) so a one-time build checks onceVariants (the regular
     FLIP 7 product) before falling back to the subscribe map — same fallback the core's own checkoutUrl
     uses, so the hidden cart items always agree with the checkout link. Blueprint C16: the subscribe PLAN
     now follows freqOf (the customer's own delivery-rhythm choice, or the bundle's default) — same rule
     checkoutUrl uses — not the money bracket's own day count. */
  function buildItems(mode) {
    if (!state.chosen.length) return [];
    var plan = null;
    if (mode === 'subscribe') {
      plan = BC.SHOPIFY.plans[BC.freqOf(state)];
      if (!plan) return [];
    }
    var items = [];
    for (var i = 0; i < state.chosen.length; i++) {
      var id = state.chosen[i];
      var v = BC.variantFor(id, mode);
      if (!v) return [];
      var item = { id: v, quantity: state.split[id] };
      if (mode === 'subscribe') item.selling_plan = plan;
      items.push(item);
    }
    return items;
  }

  function appendHidden(container, name, value) {
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = name;
    inp.value = String(value);
    container.appendChild(inp);
  }

  function fillItems(items) {
    itemsEl.innerHTML = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      appendHidden(itemsEl, 'items[' + i + '][id]', it.id);
      appendHidden(itemsEl, 'items[' + i + '][quantity]', it.quantity);
      if (it.selling_plan) appendHidden(itemsEl, 'items[' + i + '][selling_plan]', it.selling_plan);
    }
  }

  /* blueprint C16 (§0/§1): the store's own automatic discounts price the cart by minimum quantity now — no
     widget-side discount code is ever appended (checkoutUrl's contract, mirrored here). */
  function updateReturnTo() {
    if (!retEl) return;
    retEl.value = '/checkout';
  }

  function render() {
    var t = BC.totals(state);

    renderDays();
    renderWhy();
    renderTiles();

    if (pickedEl) pickedEl.textContent = BC.pickedText(state);
    hintEl.textContent = transientHint || '';

    /* blueprint C17 §2b (C1, from the 1-bag shot): pluralize like .oc-day-b already does — "1 bag", not "1 bags". */
    priceCountEl.textContent = t.bags + ' bag' + (t.bags === 1 ? '' : 's');
    wasEl.textContent = BC.money(BC.LIST_PRICE);
    wasEl.hidden = !(t.save > 0);
    nowNumEl.textContent = t.perBagText;
    billedEl.textContent = t.billedLine;
    renderPerks();
    renderLedger();

    fillItems(buildItems('subscribe'));
    updateReturnTo('subscribe');

    if (onceEl) {
      var ol = BC.onceLine(state);
      var k = ol.indexOf('? ');
      if (onceQEl) onceQEl.textContent = k > 0 ? ol.slice(0, k + 1) : ol;
      if (onceVEl) onceVEl.textContent = k > 0 ? ol.slice(k + 2) : '';
      onceEl.setAttribute('aria-disabled', t.complete ? 'false' : 'true');
    }

    ctaEl.disabled = !t.complete;
    ctaEl.textContent = BC.ctaText(state);

    root.setAttribute('data-state', JSON.stringify(state));
    root.setAttribute('data-billed', t.billedText);
    root.setAttribute('data-cart', JSON.stringify({ days: BC.freqOf(state), mode: state.mode, split: state.split }));
  }

  /* blueprint C33 (mk_evw33nyp, every device: "remove this option from every version. They should only be able to change delivery
     frequency in their account. From the flip hq."): no delivery-rhythm control on the page — the plan always follows the bundle
     (BC.freqOf with no override: 30 / 60 / 90 days for 1–3 / 4–5 / 6–10 bags). */
  root.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-inc]');
    if (incBtn) {
      if (incBtn.disabled) return;
      if (!BC.canInc(state)) {
        showToast('10 bags is the most per order.');
        return;
      }
      transientHint = null;
      state = BC.incBag(state, incBtn.getAttribute('data-inc'));
      render();
      return;
    }

    var decBtn = e.target.closest('[data-dec]');
    if (decBtn) {
      if (decBtn.disabled) return;
      transientHint = null;
      state = BC.decBag(state, decBtn.getAttribute('data-dec'));
      render();
      return;
    }

    var onceBtn = e.target.closest('.oc-once');
    if (onceBtn) {
      if (onceBtn.getAttribute('aria-disabled') === 'true') return;
      fillItems(buildItems('once'));
      updateReturnTo('once');
      if (formEl && formEl.requestSubmit) formEl.requestSubmit();
      else if (formEl) formEl.submit();
      /* blueprint C30: that submit has already read its line items (the entry list is built synchronously), so the SUBSCRIBE
         items go back now — on the store the page stays put after the one-time bags go to the cart (an AJAX add, no
         navigation), and a later Start my FLIP must add the subscription, not the one-time bags again. */
      fillItems(buildItems('subscribe'));
      return;
    }

    var dayBtn = e.target.closest('[data-days]');
    if (dayBtn) {
      var newDays = +dayBtn.getAttribute('data-days');
      state = BC.setSupply(state, newDays);
      transientHint = null;
      render();
      return;
    }
  });

  /* round six, mark mk_cx0dcduo: the ONLY submit gate — live vs. preview, complete vs. not, mapped vs. not.
     Runs whether the CTA itself was clicked or the one-time link asked the form to submit. Registered on the
     CAPTURE phase so it always runs first, ahead of anything else listening on this form. */
  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      if (!widgetEl || widgetEl.getAttribute('data-live') === '0') {
        e.preventDefault();
        hintEl.textContent = 'Preview — checkout is wired on the landers.';
        return;
      }
      if (!BC.totals(state).complete) {
        e.preventDefault();
        hintEl.textContent = BC.pickedText(state);
        return;
      }
      if (!itemsEl.children.length) {
        e.preventDefault();
        hintEl.textContent = 'Checkout for this supply is being connected.';
        return;
      }
    }, true);
  }

  render();
})();


/* ══ R2 · reviews · 2026-10-09 — curated 5★ reviews: the "View more" chain's focus + announcement, and the continuation from
   Junip's PUBLIC API after the last baked batch.
   REST STATE = THE HTML. 3 cards are visible and 15 more sit in nested <details> that open without this script (the hub's
   snapshots and a reader with JavaScript off get the same page). On Chris's lander the three kept quotes come first and the 18
   curated cards follow in six batches. This script only:
     1. moves focus to the first newly revealed card when a batch opens, and announces "Showing N of M reviews" to screen readers;
     1b. R2.1: hides the "Read more" label of a card whose text already fits the 7-line cap (the cap itself is CSS: a checkbox + a label, it
        works without this script; a card that is opened stays open);
     2. after the last baked batch, offers "Show more from Junip" (revealed only after Junip's /products answered with every
        FLIP 7 listing) and renders ONLY reviews that pass the build's runtime rules (5★, verified buyer, at least 80 chars, no
        other sales channel, no language, no religion or politics), as TEXT through createElement, never as markup. A buyer's
        photo thumbnail is shown only when both of its URLs start with https:// (a card is never dropped for a bad photo).
        A review already on the page (by id or by body) is never repeated.
   Any failure — no network, a blocked connection, a 429, a changed API shape — leaves the page exactly as it was baked:
   the live button never appears, nothing is thrown, no negative review can reach the page on any path.
   The build fills the three RV markers below (split/join): RULES = the runtime rules from parts/review-policy.cjs, FAMILY = the
   Junip product ids of the FLIP 7 listings, largest pool first, PAGE = chris | wl | glp | ag. The store key is PUBLIC (it sits in
   the store's own pages). */
(function () {
  'use strict';
  var root = document.getElementById('reviews');
  if (!root) return;
  var RULES = {"MIN_CHARS_RUNTIME":80,"CHANNEL_RE":"\\b(?:amazon|walmart|ebay|sam'?s club|target\\.com)\\b","LANGUAGE_RE":"\\b(?:damn|hell|crap|shit|ass|freaking|frickin\\w*|wtf|omfg)\\b","SENSITIVE_RE":"\\b(?:christian|jesus|church|pray(?:er|ed|ing|s)?|bible|trump|biden|republican|democrat|liberal|conservative|woke|political|politics)\\b"};
  var FAMILY = [14857132,14800295,14800298,14800306,14800304,14800305,14800307,16227381];
  var PAGE = 'chris';
  var API = 'https://api.juniphq.com/v1';
  var KEY = 'uivARb6W3898ozV6LH544hna';
  var PER_CLICK = 6, MAX_REQUESTS = 40, PAGE_SIZE = 100;
  var FLAVORS = ['Chocolate Courage', 'Vital Vanilla', 'Peanut Butter Power', 'Caramel Macchiato Crush', 'Whoa! Cookie Dough'];
  var re = function (src) { return new RegExp(src, 'i'); };
  var CHANNEL = re(RULES.CHANNEL_RE), LANGUAGE = re(RULES.LANGUAGE_RE), SENSITIVE = re(RULES.SENSITIVE_RE);
  var isChris = PAGE === 'chris';
  var CARDS = isChris ? '.rv-card, .lp-review' : '.rv-card';          /* Chris counts its three kept quotes too: 3 + 18 = 21 */
  var BATCHES = 'details.rv-batch, details.lp-more';

  /* ── what is already on the page ── */
  var shown = {};
  var baked = root.querySelectorAll('.rv-card');
  for (var i = 0; i < baked.length; i++) {
    shown['id:' + baked[i].getAttribute('data-rv-id')] = true;
    var b = baked[i].querySelector('.rv-body');
    if (b) shown['body:' + b.textContent] = true;
  }
  var total = root.querySelectorAll(CARDS).length;
  var live = document.createElement('p');
  live.className = 'rv-sr';
  live.setAttribute('aria-live', 'polite');
  root.appendChild(live);
  /* a card is shown when none of its ancestor details (inside the root) is closed — offsetParent cannot tell: a closed details still lays its content out */
  var inClosed = function (n) { for (var p = n.parentNode; p && p !== root; p = p.parentNode) { if (p.nodeName === 'DETAILS' && !p.open) return true; } return false; };
  var visible = function () { var n = 0, cards = root.querySelectorAll(CARDS); for (var k = 0; k < cards.length; k++) { if (!inClosed(cards[k])) n++; } return n; };
  var announce = function () { live.textContent = 'Showing ' + visible() + ' of ' + total + ' reviews'; };

  /* ── 1 · the chain: focus the first new card when a batch opens ── */
  var liveBtn = root.querySelector('.rv-live-btn'), liveWrap = root.querySelector('.rv-live'), liveGrid = root.querySelector('.rv-live-grid'), endLine = root.querySelector('.rv-end');
  var liveReady = false;
  var setLive = function (on) { if (liveWrap) liveWrap.hidden = !on; };
  var allOpen = function () { return !root.querySelector('details.rv-batch:not([open]), details.lp-more:not([open])'); };
  /* 1b · the read-more cap: a card whose text fits 7 lines needs no label. A card inside a closed batch has no layout yet, so it is left alone until its batch opens. */
  var trimTimer = null;
  var trim = function () {
    var xs = root.querySelectorAll('.rv-card .rv-x:not(:checked)');
    for (var t = 0; t < xs.length; t++) {
      var body = xs[t].nextElementSibling, lab = body ? body.nextElementSibling : null;
      if (!body || !lab || lab.className !== 'rv-more') continue;
      if (!body.clientHeight && !body.scrollHeight) continue;
      lab.hidden = body.scrollHeight <= body.clientHeight + 1;
    }
  };
  window.addEventListener('resize', function () { clearTimeout(trimTimer); trimTimer = setTimeout(trim, 150); });
  window.addEventListener('load', trim);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(trim);
  trim();
  var batches = root.querySelectorAll(BATCHES);
  for (var j = 0; j < batches.length; j++) {
    batches[j].addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.open) return;
      trim();
      var first = d.querySelector('.rv-card');
      if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: false }); }
      announce();
      if (!d.querySelector(BATCHES) && liveReady) setLive(true);      /* the last baked batch just opened */
    });
  }
  if (!window.fetch || !window.Promise) return;

  /* ── helpers that never trust the API's shape ── */
  var isInt = function (n) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && n >= 0; };
  var isHttps = function (s) { return typeof s === 'string' && s.indexOf('https://') === 0; };
  var okToShow = function (r) {
    if (!r || typeof r !== 'object') return false;
    if (r.rating !== 5 || r.verified_buyer !== true) return false;
    var body = typeof r.body === 'string' ? r.body : '';
    if (body.length < RULES.MIN_CHARS_RUNTIME) return false;
    var text = (typeof r.title === 'string' ? r.title : '') + ' ' + body;
    if (CHANNEL.test(text) || LANGUAGE.test(text) || SENSITIVE.test(text)) return false;
    if (shown['id:' + r.id] || shown['body:' + body]) return false;
    return true;
  };
  var nameOf = function (r) { var c = r.customer && typeof r.customer === 'object' ? r.customer : {}; return ((typeof c.first_name === 'string' ? c.first_name : '') + ' ' + (typeof c.last_name === 'string' ? c.last_name : '')).replace(/\s+/g, ' ').trim(); };
  var flavorOf = function (r) { var t = typeof r.target_title === 'string' ? r.target_title.toLowerCase() : ''; for (var f = 0; f < FLAVORS.length; f++) { if (t.indexOf(FLAVORS[f].toLowerCase()) !== -1) return FLAVORS[f]; } return ''; };
  var monthOf = function (iso) { var d = new Date(iso); if (isNaN(d)) return ''; return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getUTCMonth()] + ' ' + d.getUTCFullYear(); };
  var el = function (tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  var capOf = function (id) { var inp = el('input', 'rv-x'); inp.setAttribute('type', 'checkbox'); inp.id = 'rvx-' + PAGE + '-' + id; var lab = el('label', 'rv-more', 'Read more'); lab.setAttribute('for', inp.id); return [inp, lab]; };
  var showTitle = function (title, body) { if (!title) return false; var t = title.replace(/(\.{3}|…)\s*$/, '').replace(/\s+/g, ' ').trim().slice(0, 40).toLowerCase(); return body.replace(/\s+/g, ' ').trim().toLowerCase().indexOf(t) !== 0; };
  var get = function (url) {
    return fetch(url, { headers: { 'Junip-Store-Key': KEY, 'Accept': 'application/json' } }).then(function (res) { if (res.status !== 200) throw new Error('HTTP ' + res.status); return res.json(); });
  };
  /* the buyer's photo thumbnails (at most 3): a pair is used only when BOTH urls start with https:// — anything else is skipped, the card stays */
  var photosOf = function (r, name) {
    var list = Array.isArray(r.photo_urls) ? r.photo_urls : [], keep = [];
    for (var q = 0; q < list.length && keep.length < 3; q++) {
      var u = list[q];
      if (u && typeof u === 'object' && isHttps(u.thumbnail) && isHttps(u.large)) keep.push(u);
    }
    if (!keep.length) return null;
    var wrap = el('div', 'rv-photos');
    for (var w = 0; w < keep.length; w++) {
      var a = el('a', 'rv-photo');
      a.setAttribute('href', keep[w].large); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener');
      var img = document.createElement('img');
      img.setAttribute('src', keep[w].thumbnail); img.setAttribute('alt', 'Photo from ' + (name || 'a customer') + "'s review");
      img.setAttribute('width', '88'); img.setAttribute('height', '88'); img.setAttribute('decoding', 'async');
      a.appendChild(img); wrap.appendChild(a);
    }
    return wrap;
  };

  /* ── a card, the same shape as the baked ones (text only) ── */
  var card = function (r) {
    var name = nameOf(r), body = r.body, title = typeof r.title === 'string' ? r.title : '', flavor = flavorOf(r), when = monthOf(r.created_at), photos = photosOf(r, name);
    var c;
    if (isChris) {
      c = el('article', 'lp-review rv-card');
      var who = el('div', 'lp-who', name + ' ');
      var ver = el('span', 'lp-verified'); ver.appendChild(document.importNode(root.querySelector('.lp-verified svg'), true)); ver.appendChild(document.createTextNode('Verified buyer'));
      who.appendChild(ver); c.appendChild(who);
      c.appendChild(document.importNode(root.querySelector('.lp-review .lp-stars'), true));
      var stack = el('div', 'lp-stack'); stack.style.gap = '18px';
      if (showTitle(title, body)) stack.appendChild(el('h3', null, title));
      var cap1 = capOf(r.id); stack.appendChild(cap1[0]); stack.appendChild(el('p', 'rv-body', body)); stack.appendChild(cap1[1]); c.appendChild(stack);
      if (photos) c.appendChild(photos);
      var meta = el('div', 'lp-meta');
      if (r.would_recommend === true) { var rec = el('span', 'lp-rec'); rec.appendChild(document.importNode(root.querySelector('.lp-rec svg'), true)); rec.appendChild(document.createTextNode('Would recommend')); meta.appendChild(rec); }
      if (flavor) meta.appendChild(el('span', 'lp-flavor', flavor));
      if (when) { var t1 = el('time', null, when); t1.setAttribute('datetime', String(r.created_at).slice(0, 10)); meta.appendChild(t1); }
      c.appendChild(meta);
    } else {
      c = el('figure', 'quotecard rv-card');
      if (showTitle(title, body)) c.appendChild(el('p', 'rv-title', title));
      var cap2 = capOf(r.id); c.appendChild(cap2[0]); c.appendChild(el('blockquote', 'rv-body', body)); c.appendChild(cap2[1]);
      if (photos) c.appendChild(photos);
      var cap = el('figcaption', 'rv-meta');
      cap.appendChild(el('span', 'eyebrow rv-name', name));
      cap.appendChild(el('span', 'rv-chip', 'Verified buyer'));
      if (flavor) cap.appendChild(el('span', 'rv-flavor', flavor));
      if (when) { var t2 = el('time', 'rv-date', when); t2.setAttribute('datetime', String(r.created_at).slice(0, 10)); cap.appendChild(t2); }
      c.appendChild(cap);
    }
    c.setAttribute('data-rv-id', String(r.id));
    c.setAttribute('data-rv-live', '1');
    return c;
  };

  /* ── 2 · the gate: Junip's /products must answer with every FLIP 7 listing before "Show more" can appear ── */
  get(API + '/products?page[size]=100').then(function (j) {
    var list = j && j.products; if (!Array.isArray(list)) throw new Error('shape');
    var seen = {}, n = 0;
    for (var p = 0; p < list.length; p++) {
      var pr = list[p]; if (!pr || typeof pr !== 'object') continue;
      if (FAMILY.indexOf(pr.id) === -1) continue;
      var d = pr.rating_distribution || {};
      if (!isInt(pr.rating_count) || !isInt(d['5'])) throw new Error('shape');
      if (!seen[pr.id]) { seen[pr.id] = true; n++; }
    }
    if (n < FAMILY.length) throw new Error('family incomplete');
    liveReady = true;
    if (allOpen()) setLive(true);                                                            /* every baked batch is already open */
  }).catch(function () { /* the baked reviews stand; the live button never appears */ });

  /* ── 3 · the continuation: newest 5★ first, listing by listing, the same rules as the build ── */
  var queue = [], product = 0, after = null, requests = 0, exhausted = false, busy = false;
  var fetchMore = function () {
    if (exhausted || requests >= MAX_REQUESTS) { exhausted = true; return Promise.resolve(); }
    if (product >= FAMILY.length) { exhausted = true; return Promise.resolve(); }
    requests++;
    var url = API + '/product_reviews?filter[product_ids]=' + FAMILY[product] + '&filter[rating]=5&include=customer&page[size]=' + PAGE_SIZE + (after ? '&page[after]=' + encodeURIComponent(after) : '');
    return get(url).then(function (j) {
      var list = j && j.product_reviews; if (!Array.isArray(list)) throw new Error('shape');
      for (var k = 0; k < list.length; k++) { if (okToShow(list[k])) { queue.push(list[k]); shown['id:' + list[k].id] = true; shown['body:' + list[k].body] = true; } }
      after = j.meta && j.meta.page ? j.meta.page.after : null;
      if (!after || !list.length) { product++; after = null; }
      if (queue.length < PER_CLICK) return fetchMore();                    /* not enough yet: the next call also notices the end of the listings / the request cap, in this same click */
    });
  };
  var render = function () {
    var n = 0;
    while (queue.length && n < PER_CLICK) { var r = queue.shift(); liveGrid.appendChild(card(r)); total++; n++; }
    var cards = liveGrid.querySelectorAll('.rv-card');
    var first = cards[cards.length - n];
    if (n && first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: false }); }
    announce();
    trim();
    if (!queue.length && exhausted) { setLive(false); if (endLine) endLine.hidden = false; }
  };
  if (liveBtn && liveGrid) liveBtn.addEventListener('click', function () {
    if (busy) return; busy = true; liveBtn.setAttribute('aria-busy', 'true');
    (queue.length >= PER_CLICK ? Promise.resolve() : fetchMore()).then(function () { render(); })
      .catch(function () { exhausted = true; setLive(false); if (queue.length) render(); })
      .then(function () { busy = false; liveBtn.removeAttribute('aria-busy'); });
  });
})();
